<template>
  <div v-click-outside="onClickOutside" id="box--months">
    <span class="submenu--item" @click="openmonths()">
      Streaming Month
      <font-awesome-icon class="submenu--icon" icon="chevron-down" />
    </span>
    <div class="box--months">
      <div class="box--months--triangulo"></div>
      <span class="box--reset" @click="closemonths()">X Reset</span>
      <template v-for="g in items">
        <span :key="g.id" class="box--item" :id="g.id" @click="selectMonth(g)"
          ><font-awesome-icon class="box--icon" icon="check" />
          {{ g.name }}</span
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [],
    months: [],
  }),

  created() {
    let month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    let d = new Date();
    let n = d.getMonth();
    let y = d.getFullYear();

    for (let index = n; index < n + 4; index++) {
      let el = { id: "", name: "" };
      if (index === 12) {
        let m = y + 1;
        el.id = "01/" + m;
        el.name = month[0];
        this.items.push(el);
      } else if (index === 13) {
        let m = y + 1;
        el.id = "02/" + m;
        el.name = month[1];
        this.items.push(el);
      } else if (index === 14) {
        let m = y + 1;
        el.id = "03/" + m;
        el.name = month[2];
        this.items.push(el);
      } else {
        let m = index + 1;
        el.id = m + "/" + y;
        el.name = month[index];
        this.items.push(el);
      }
    }
  },
  methods: {
    onClickOutside() {
      let el = document.getElementsByClassName("box--months");
      el[0].classList.remove("menu-visible");
    },

    closemonths() {
      this.months = [];
      this.$store.commit("EDIT_MONTHS", this.months.toString());
      let item = document.getElementsByClassName("box--item");
      item.forEach((element) => {
        let icon = element.children[0];
        element.classList.remove("active");
        icon.classList.remove("active-icon");
      });
    },

    openmonths() {
      let el = document.getElementsByClassName("box--months");
      el[0].classList.toggle("menu-visible");
    },
    selectMonth(i) {
      let item = document.getElementById(i.id);
      let icon = item.children[0];
      item.classList.toggle("active");
      icon.classList.toggle("active-icon");

      const index = this.months.findIndex((element) => element === i.id);
      if (index != -1) {
        this.months.splice(index, 1);
      } else {
        this.months.push(i.id);
      }

      this.$store.commit("EDIT_MONTHS", this.months.toString());
    },
  },
};
</script>

<style scoped>
.box--months {
  background-color: #1c2531;
  display: grid;
  grid-template-columns: repeat(1, 180px);
  column-gap: 25px;
  color: #d5d5d5;
  font-size: 0.8em;
  padding: 4px 20px 15px 20px;
  position: absolute;
  z-index: 9000;
  margin-top: 10px;
  margin-left: 0px;
  visibility: hidden;
}
.submenu--item {
  color: #d5d5d5;
  font-size: 15px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}
.submenu--icon {
  font-weight: thin;
  padding-left: 10px;
  align-self: end;
}

.box--months--triangulo {
  position: absolute;
  width: 20px;
  height: 10px;
  top: -8px;
  left: 15px;
  background: #1c2531;

  /* The points are: centered top, left bottom, right bottom */
  clip-path: polygon(50% 0, 0 100%, 100% 100%);
}

.box--title {
  color: white;
  font-size: 1.3em;
  padding-bottom: 10px;
}
.box--reset {
  align-self: top;
  justify-self: end;
  cursor: pointer;
}

.box--item {
  padding: 5px;
  margin: 2px;
  cursor: pointer;
}

.box--icon {
  padding-right: 5px;
}

.active {
  color: white;
  font-weight: 600;
  border: 1px solid #738092;
  border-radius: 7px;
}
.active-icon {
  color: #94c659;
}
.menu-visible {
  visibility: visible;
}

@media (min-width: 600px) and (max-width: 960px) {
  .submenu--item {
    font-size: 0.75em;
  }
  .menu--item-select {
    align-self: end;
    column-gap: 0px;
  }
}
@media (max-width: 600px) {
  .box--months {
    grid-template-columns: repeat(1, 120px);
  }
  .submenu--item {
    font-size: 0.5em;
  }
  .box--months {
    margin-left: -50px;
  }
  .box--months--triangulo {
    left: 65px;
  }
}
</style>
